import { render, staticRenderFns } from "./template9.vue?vue&type=template&id=1c1d434c&scoped=true"
import script from "./template9.vue?vue&type=script&lang=js"
export * from "./template9.vue?vue&type=script&lang=js"
import style0 from "./template9.vue?vue&type=style&index=0&id=1c1d434c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1d434c",
  null
  
)

export default component.exports